import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4.469 20H19.53c1.54 0 2.503-1.669 1.73-3.002L13.732 3.99c-.77-1.33-2.692-1.331-3.462 0L2.738 16.998C1.966 18.33 2.928 20 4.468 20m8.573-12.8h-2.1l.07 6.762h1.974zm-2.324 8.68c0 .7.56 1.26 1.274 1.26.728 0 1.288-.56 1.288-1.26s-.56-1.246-1.288-1.246c-.714 0-1.274.546-1.274 1.246",
      clipRule: "evenodd"
    }
  )
);
var SvgWarningFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var WarningFilled_default = SvgWarningFilled;

export { WarningFilled_default as default };
